import { ThirdPartyPlaylistResponse } from 'anchor-server-common/utilities/spotifyApi';
import { normalizePlaylistsResponse } from 'anchor-server-common/utilities/spotifyHelper/dataNormalization';
import { isRawResponse } from '../../../../../helpers/music';

export async function fetchSpotifyPlaylist(): Promise<ThirdPartyPlaylistResponse> {
  const response = await fetch(`/api/proxy/v3/music/spotify/playlists`, {
    method: 'GET',
    credentials: 'same-origin',
  });

  if (!response.ok) {
    throw new Error(`Could not fetch user's playlists`);
  }

  const responsePlaylists = await response.json();

  if (isRawResponse(responsePlaylists)) {
    return normalizePlaylistsResponse(responsePlaylists);
  }

  return responsePlaylists;
}
